<template>
    <div class="min_box">
        <div class="flex" >
            <div><a-button class="top_btn" type="primary"   @click="exportList()"  >
                批量导出
            </a-button>
                <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template></span></div>
            <div class="search-group flex">
                <div class="seachList">
                    <span class="">客户地区:</span>
                    <a-select v-model="search.a_team_customer_service_id" class="seachs" allowClear mode="multiple" placeholder="请选择" :showArrow="true">
                        <a-select-option :value="item.value" :key="index" v-for="(item,index) in teamList">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </div>
                <a-button type="primary" class="top_btn" @click="getList()">搜索</a-button>
                <a-button   class="top_btn" @click="empty">重置</a-button>
            </div>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" @change="handleChange" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" >
            <span slot="action" slot-scope="text, record">
                <a @click="gotoStatistics(record)">{{text.customer_count}}</a>
            </span>
        </a-table>

    </div>

</template>

<script>
    import API from "./api";
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [

        {
            title: "版本名",
            key: "name",
            width:"50%",
            ellipsis: true,
            dataIndex: "name",
        },
        {
            title: "客户数",
            key: "action",
            scopedSlots: {customRender: "action"}
            /* key: "customer_count",
            dataIndex: "customer_count", */
        }
    ];
    export default {
        name: 'index',
        data() {
            return {
                loading: true,
                data: [],
                selectedRowKeys: [], // Check here to configure the default column
                columns,
                a_team_customer_service_id:"",
                search: {
                    a_team_customer_service_id: [],
                },
                teamList:[],
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/RankVersion"; //设置左侧导航2-2 active
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            empty(){
                this.search.a_team_customer_service_id=[]
                this.getList()
            },
            handleChange(pagination, filters, sorter) {
            },
            exportList(){
                API.service.EXPORT({name:this.a_team_customer_service_id ,ids:this.selectedRowKeys }).then(res => {
                    window.open( `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`  )
                })
            },
            getList(page) {
                this.a_team_customer_service_id = this.search.a_team_customer_service_id
                let seachData = JSON.parse(JSON.stringify(this.search))
                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.teamList = res.data.data.team
                    this.data = res.data.data.list.data
                    this.pagination.total=res.data.data.list.total
                    this.pagination.pageSize=res.data.data.list.per_page
                    this.pagination.current=res.data.data.list.current_page
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },

            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            gotoStatistics(row){
                this.$router.push(`/DataStatistics/WebStatistics?id=${row.id}&name=${row.name}&type=version`)
            }
        },
        mounted() {
            this.getList()
        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    .search-group {
        float: right;
    }
    .search-group .seachs {
        width: 200px;
        margin: 0 8px 0 10px ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }
    .top .flex{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box;width: 60%;margin-bottom: 20px}
    .min_box{width: 60%}
</style>
